import { useTranslation } from "../../../../../../hooks";
import { utcToLocal } from "../../../../../../helpers";
import { T } from "../../../../../../constants";
import { KeyValue } from "../key-value";
import { Line } from "../line";

interface BetInfoProps {
  barCode?: number;
  ticketId: number;
  betTypeName?: string;
  userName?: string;
  date: string | Date;
  showUserName?: boolean;
}

export const BetInfo: React.FC<BetInfoProps> = ({
  date,
  barCode,
  userName,
  ticketId,
  betTypeName,
  showUserName,
}) => {
  const t = useTranslation();

  return (
    <>
      <div>
        <KeyValue
          label={t(T.DATE)}
          value={utcToLocal(date, "DD.MM.YYYY H:mm:ss")}
          textBold
        />

        {showUserName && userName && (
          <KeyValue label={t(T.CASHIER_NAME)} value={userName} textBold />
        )}

        <KeyValue label={t(T.TICKET_ID)} value={ticketId} textBold />

        {barCode ? (
          <KeyValue label={t(T.BARCODE)} value={barCode} textBold />
        ) : null}

        {betTypeName ? (
          <KeyValue label={t(T.BET_TYPE)} value={t(betTypeName)} textBold />
        ) : null}
      </div>
      <Line type="solid" />
    </>
  );
};
